/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCycleDays } from 'app/entities/cycle-day/cycle-day.reducer';
import { PainLevel } from 'app/shared/model/enumerations/pain-level.model';
import { createEntity, getEntity, reset, updateEntity } from './pain.reducer';

export const PainUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cycleDays = useAppSelector(state => state.cycleDay.entities);
  const painEntity = useAppSelector(state => state.pain.entity);
  const loading = useAppSelector(state => state.pain.loading);
  const updating = useAppSelector(state => state.pain.updating);
  const updateSuccess = useAppSelector(state => state.pain.updateSuccess);
  const painLevelValues = Object.keys(PainLevel);

  const handleClose = () => {
    navigate(`/pain${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCycleDays({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...painEntity,
      ...values,
      cycleDay: cycleDays.find(it => it.id.toString() === values.cycleDay?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          crampLevel: 'SLIGHT',
          opLevel: 'SLIGHT',
          headacheLevel: 'SLIGHT',
          backacheLevel: 'SLIGHT',
          nauseaLevel: 'SLIGHT',
          migraneLevel: 'SLIGHT',
          ...painEntity,
          cycleDay: painEntity?.cycleDay?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pain.home.createOrEditLabel" data-cy="PainCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pain.home.createOrEditLabel">Create or edit a Pain</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pain-id"
                  label={translate('tinyMedicRestApp.pain.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.cramps')}
                id="pain-cramps"
                name="cramps"
                data-cy="cramps"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.crampLevel')}
                id="pain-crampLevel"
                name="crampLevel"
                data-cy="crampLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.ovulationPain')}
                id="pain-ovulationPain"
                name="ovulationPain"
                data-cy="ovulationPain"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.opLevel')}
                id="pain-opLevel"
                name="opLevel"
                data-cy="opLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.headache')}
                id="pain-headache"
                name="headache"
                data-cy="headache"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.headacheLevel')}
                id="pain-headacheLevel"
                name="headacheLevel"
                data-cy="headacheLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.backache')}
                id="pain-backache"
                name="backache"
                data-cy="backache"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.backacheLevel')}
                id="pain-backacheLevel"
                name="backacheLevel"
                data-cy="backacheLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.nausea')}
                id="pain-nausea"
                name="nausea"
                data-cy="nausea"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.nauseaLevel')}
                id="pain-nauseaLevel"
                name="nauseaLevel"
                data-cy="nauseaLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.tenderBreasts')}
                id="pain-tenderBreasts"
                name="tenderBreasts"
                data-cy="tenderBreasts"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.migraine')}
                id="pain-migraine"
                name="migraine"
                data-cy="migraine"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.migraneLevel')}
                id="pain-migraneLevel"
                name="migraneLevel"
                data-cy="migraneLevel"
                type="select"
              >
                {painLevelValues.map(painLevel => (
                  <option value={painLevel} key={painLevel}>
                    {translate(`tinyMedicRestApp.PainLevel.${painLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.other')}
                id="pain-other"
                name="other"
                data-cy="other"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.comments')}
                id="pain-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.active')}
                id="pain-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.draft')}
                id="pain-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.cursor')}
                id="pain-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.lastUpdated')}
                id="pain-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.microSec')}
                id="pain-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pain.timestampEntry')}
                id="pain-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="pain-cycleDay"
                name="cycleDay"
                data-cy="cycleDay"
                label={translate('tinyMedicRestApp.pain.cycleDay')}
                type="select"
              >
                <option value="" key="0" />
                {cycleDays
                  ? cycleDays.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pain" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PainUpdate;
